module.exports = __webpack_public_path__ + "img/kankou_11.22a52feb.jpg";